import React from 'react';
import {
  Avatar,
  ButtonBase,
} from '@mui/material';
import { API_BASE_URL } from '../../../services/api';

interface ProductThumbnailProps {
  imageId: number;
  size: number | { xs: number; sm: number };
  alt?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export default function ProductThumbnail({
  imageId,
  size,
  alt,
  onClick,
}: ProductThumbnailProps) {
  const avatar = (
    <Avatar
      src={`${API_BASE_URL}/images/${imageId}`}
      alt={alt}
      variant="rounded"
      sx={{
        width: size,
        height: size,
        bgcolor: 'common.white',
        border: 1,
        borderColor: 'divider',
        '& .MuiAvatar-img': {
          objectFit: 'contain',
          p: 0.5,
          boxSizing: 'border-box',
        },
      }}
    />
  );

  if (!onClick) {
    return avatar;
  }

  return (
    <ButtonBase
      aria-label="Переглянути фото"
      onClick={onClick}
      sx={{
        borderRadius: 1,
        cursor: 'zoom-in',
      }}
    >
      {avatar}
    </ButtonBase>
  );
}
